// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"IK-z","carouselContainer":"JK-z"};